const affix = '-widget';

export default function journeyToWidget(journey) {
  return `oc-${journey}${journey.indexOf(affix) === -1 ? affix : ''}`;
}
